import React from "react";
import PropTypes from "prop-types";
import { Chip, Tooltip } from "@mui/material";
import { REMITTANCE_TOKENS } from "../../../../components/sepa/remittanceTokens";

export default function RemittanceSegmentChip({ segment, onDelete }) {
  if (!segment) return null;

  if (segment.type === "text" && !segment.value?.trim()) {
    return null;
  }

  if (segment.type === "token") {
    const definition = REMITTANCE_TOKENS.find((token) => token.key === segment.key);
    const label = definition?.label || `{{${segment.key}}}`;
    const description = definition?.description || definition?.sample;

    const chip = (
      <Chip variant="outlined" color="default" label={label} onDelete={onDelete} />
    );

    if (!description) {
      return chip;
    }

    return (
      <Tooltip title={description} arrow>
        {chip}
      </Tooltip>
    );
  }

  return (
    <Chip
      variant="filled"
      color="default"
      label={segment.value || "(Text)"}
      onDelete={onDelete}
    />
  );
}

RemittanceSegmentChip.propTypes = {
  segment: PropTypes.shape({
    type: PropTypes.oneOf(["token", "text"]).isRequired,
    key: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  onDelete: PropTypes.func,
};
